import React from 'react';

const defaultContext = { image: 'value' };
const AppContext = React.createContext(defaultContext);

export { AppContext };
